var map = {
	"./1inch.svg": 1316,
	"./arbitrum-disable.svg": 1317,
	"./arbitrum.svg": 1318,
	"./authereum.svg": 1319,
	"./binance.svg": 1320,
	"./bitsky.svg": 1321,
	"./coin98.svg": 1322,
	"./coinbase.svg": 1323,
	"./fewcha.jpeg": 1324,
	"./fortmatic.svg": 1325,
	"./funfairwallet.svg": 1326,
	"./keepkey.svg": 1327,
	"./ledger.svg": 1328,
	"./martian.jpeg": 1329,
	"./metamask.svg": 1330,
	"./mew.svg": 1331,
	"./petra.jpeg": 1332,
	"./phantom.svg": 1333,
	"./pontem.jpeg": 1334,
	"./portis.svg": 1335,
	"./torus.svg": 1336,
	"./trezor.svg": 1337,
	"./venly.svg": 1338,
	"./walletconnect.svg": 1339,
	"./walletlink.svg": 1340,
	"./web3.svg": 1341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1315;